import { useMemo } from 'react';

import { ChartConfig } from 'components/ui/chart';

import { SplitLegendItems } from './types';
import { processLegendItems, splitLegendItemsByVisibility } from './utils';

export function useLegendItemsVisibility(
  payload: any[] | undefined,
  nameKey: string | undefined,
  config: ChartConfig,
  maxVisibleItems: number
): SplitLegendItems {
  return useMemo(() => {
    if (!payload || payload.length === 0) {
      return {
        visibleItems: [],
        hiddenItems: [],
        shouldShowMore: false
      };
    }

    const processedItems = processLegendItems(payload, nameKey, config);
    return splitLegendItemsByVisibility(processedItems, maxVisibleItems);
  }, [payload, nameKey, config, maxVisibleItems]);
}
